let preference = {
    title: "Personal preference",
    num: "Time",
    time: "Hour",
    select: {
        title: 'Show recent',
        option01: "One week",
        option02: "Two weeks",
        option03: "Three weeks",
        option04: "One month",
        option05: "Two months",
        option06: "Three months",
    },
    apply: {
        title: "Common applications"
    },
    authentication: {
        title: "Common authentication methods"
    },
    cause: {
        title: "Authentication failure reason"
    },
    facility: {
        title: "Common equipment"
    },
    location: {
        title: "Common location"
    },
    timeFrame: {
        title: "Distribution of Certification Periods"
    },
}

export default preference